export default __webpack_public_path__ + "static/media/gallery_03.067a0171.jpg";